// src/utils/authUtils.js
import { jwtDecode } from "jwt-decode";

export function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // in seconds
    return decoded.exp < now;
  } catch (error) {
    return true; // If decoding fails, treat as expired
  }
}
